import React, { useState } from "react";

const WardAllocation = ({ wards, onWardSelect }) => {
  const [selectedWard, setSelectedWard] = useState("");

  const handleWardChange = (e) => {
    setSelectedWard(e.target.value);
    onWardSelect(e.target.value); // Pass selected ward back to parent
  };

  return (
    <div>
      <h2 className="text-lg font-bold mb-4">Ward Allocation</h2>
      <label className="block text-gray-600 mb-2">Select Ward</label>
      <select
        value={selectedWard}
        onChange={handleWardChange}
        className="w-full border border-gray-300 rounded-md p-2"
      >
        <option value="" disabled>
          Choose a ward
        </option>
        {wards.map((ward) => (
          <option key={ward.wardId} value={ward.wardId}>
            {ward.name} - ₹{ward.costPerDay}/day ({ward.availableBeds} beds
            available)
          </option>
        ))}
      </select>
    </div>
  );
};

export default WardAllocation;
